<template>
  <div>
    门店位置
  </div>
</template>

<script>
export default {
  name: 'Location',
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
